<template>
  <div>
    <list-page-header />
    <yv-index
      :path="path"
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :tableActionsComponent="TableActions"
      :formatTableData="formatTableData"
      :sortable="sortable"
      :sort-data="sortData"
      mainField="full_name"
      ref="termsTable"
    >
    </yv-index>
    <!-- copy term -->
    <common-modal
      height="auto"
      width="70%"
      :name="currentTerm.name"
      :title="titleCopyTerm"
      :primaryAction="primaryAction"
      :secondary-actions="secondaryActions"
    >
      <template #modal-body>
        <copy-term-form
          :form-data="formData"
          :serverValidations="serverValidations"
          :current-term="currentTerm"
        ></copy-term-form>
      </template>
    </common-modal>
  </div>
</template>

<script>
import CopyTermForm from "./CopyTermForm";
import { YvIndex } from "@/components/Base";
import { service_names, service_paths } from "@/constants/Services";
import Header from "./Header";
import TableActions from "./TableActions.vue";
import CommonModal from "../../../components/Base/CommonModal.vue";
import { genErrMsgOj, getId, Message } from "@/helpers/utils";
import Swal from "sweetalert2";
import { convertDateFromServer } from "../../../helpers/datetime-helper";
import { DEFAULT_OPTION_ALL, SCHOOL_YEARS } from "../../../constants";
import omit from "lodash/omit";

const initCopyTermForm = () => ({
  destination_term_id: "",
  role_option: true,
  options: {
    students: false,
    teachers: false,
    keep_info_intact: false
  }
});
export default {
  name: "ListPage",
  components: {
    YvIndex,
    ListPageHeader: Header,
    CommonModal,
    CopyTermForm
  },
  data() {
    return {
      path: service_paths.terms,
      TableActions,
      formData: {},
      serverValidations: {},
      sortable: ["name", "full_name", "status", "start_date", "end_date"],
      sortData: {
        currentSort: "id",
        currentSortOrder: "desc"
      },
      // copy term
      currentTerm: {
        name: ""
      },
      formSearch: [
        {
          label: "term.term_name",
          name: "name__~",
          value: "",
          type: "input",
          width: "33"
        },
        {
          label: "student.school_year",
          name: "school_year",
          value: "",
          type: "select",
          options: [...DEFAULT_OPTION_ALL, ...SCHOOL_YEARS],
          width: "33"
        },
        {
          label: "common.status",
          name: "status",
          value: "",
          type: "select",
          options: [
            ...DEFAULT_OPTION_ALL,
            {
              id: "On-going",
              name: "common.on_going"
            },
            {
              id: "Concluded",
              name: "common.concluded"
            }
          ],
          width: "33"
        }
      ],
      columns: {
        name: "term.col_term_name",
        school_year: "School year",
        total_class: "term.col_total_class",
        status: "term.col_status",
        start_date: "term.col_start_date",
        end_date: "term.col_end_date"
      },
      primaryAction: {
        title: "common.copy",
        action: this.doCopy
      },
      secondaryActions: [
        {
          title: "common.cancel",
          action: () => {
            this.$modal.hide(this.currentTerm.name);
          }
        }
      ]
    };
  },
  computed: {
    titleCopyTerm() {
      return "term.copy_term_class";
    }
  },
  methods: {
    // copy action
    copyAction(formData, currentPath) {
      this.$axios
        .post(currentPath, formData)
        .then(() => {
          Message.success(this.$t("term.copy_success"));
          this.$modal.hide(this.currentTerm.name);
          this.reFetchTableData();
        })
        .catch(error => {
          const errData = error.response?.data;

          if (errData) {
            this.serverValidations = genErrMsgOj(errData.messages);
          }
        });
    },
    doCopy() {
      let formData = this.generateFormData();
      let path = this.generatePath();
      this.copyAction(formData, path);
    },
    generateFormData() {
      let formData = Object.assign(
        {
          source_term_id: this.currentTerm.id,
          destination_term_id: this.formData.destination_term_id,
          options: this.formData.options
        },
        {}
      );
      if (!this.formData.role_option) {
        formData = omit(formData, "options");
      }
      return formData;
    },
    generatePath() {
      return this.formData.role_option
        ? `${service_names.school}/terms-classes-copy-options`
        : `${service_names.school}/terms-classes-copy`;
    },
    confirmCopy(item) {
      this.currentTerm = item;
      this.formData = initCopyTermForm();
      this.serverValidations = {};
      this.$nextTick(() => {
        this.$modal.show(this.currentTerm.name);
      });
    },
    formatTableData(tableData) {
      tableData.map(item => {
        item.school_year =
          item.school_year && `${item.school_year} (S${item.semester_number})`;
        item.total_class = item.classes.length;
        item.status =
          item.status === "On-going"
            ? this.$t("common.on_going")
            : this.$t("common.concluded");
        item.start_date = convertDateFromServer(item.start_date, "date");
        item.end_date = convertDateFromServer(item.end_date, "date");
      });
      return tableData;
    },
    reFetchTableData() {
      return this.$refs.termsTable.getTableData();
    },
    // conclude
    confirmConclude(item) {
      Swal.fire({
        title: this.$t("common.confirmation"),
        text: this.$t("term.text_conclude_term"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: this.$t("common.conclude"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.concludeTerm(item);
        }
      });
    },
    concludeTerm(item) {
      const termId = item.id;
      this.$axios
        .post(`${service_paths.terms}/${termId}/conclude`)
        .then(async () => {
          await this.reFetchTableData();
          Message.success(this.$t("term.message_conclude_successfully"));
        });
    },
    //delete
    async deleteTerm(data) {
      const id = getId(data);
      await this.$axios.delete(`${this.path}/${id}`).then(async () => {
        await this.reFetchTableData();
        Message.success(this.$t("common.delete_success"));
      });
    },
    confirmDelete(data) {
      if (data.classes.length) {
        Swal.fire({
          title: this.$t("common.confirmation"),
          text: this.$t("term.text_cant_delete"),
          confirmButtonClass: "md-button md-success btn-fill",
          confirmButtonText: this.$t("common.ok"),
          buttonsStyling: false
        });
      } else {
        Swal.fire({
          title: this.$t("common.confirmation"),
          text: this.$t("term.text_confirm_delete"),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-danger btn-fill",
          cancelButtonClass: "md-button md-secondary btn-fill",
          confirmButtonText: this.$t("common.delete"),
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.deleteTerm(data);
          }
        });
      }
    }
  },
  provide() {
    return {
      confirmCopy: this.confirmCopy,
      confirmDelete: this.confirmDelete,
      confirmConclude: this.confirmConclude,
      reFetchTableData: this.reFetchTableData
    };
  }
};
</script>
